// extracted by mini-css-extract-plugin
export default {"link":"messageText_link__TjPpn","highlight":"messageText_highlight__FoJpR"};